import { OrganizationWithLogoUrl } from '@melio/platform-api';

export const sortOrganizations = (organizations: OrganizationWithLogoUrl[]) =>
  [...organizations].sort((a, b) => {
    const aCompanyName = a.name ?? '';
    const bCompanyName = b.name ?? '';

    return aCompanyName.localeCompare(bCompanyName, 'en', { sensitivity: 'base' });
  });
